import DatacorLogoSpinner from '../../../../../../components/datacorLogoSpinner/DatacorLogoSpinner';
import React from 'react';
import FormPartial from '../../../../../../components/form/formContainer/FormPartial';
import {
    SdsCasComposition,
    SdsHeader,
} from '../../../../../../types/formulation';
import SubSection3_1Form from './subSections/subSection3_1/SubSection3_1Form';
import SdsCasCompositionGrid from './SdsCasCompositionGrid';
import { SdsBlobSectionFormProps } from '../shared/blobs/hooks/SdsBlobSectionFormProps';
import CheckBoxInput from '../../../../../../components/form/formInputs/CheckBoxInput/CheckBoxInput';
import TranslatableText from '../../../../../../components/i18n/TranslatableText';
import { SDSFormDefs } from '../../../../../../constants/i18n/translations/termDefinitions/formulation';
import { ChildEditableGridWithCopyFunctionProps } from '../../../../../grid/utils/editableGrid/ChildEditableGridWithCopyFunctionProps';

const SdsCasCompositionForm = (
    props: ChildEditableGridWithCopyFunctionProps<
        SdsHeader,
        SdsCasComposition
    > &
        SdsBlobSectionFormProps<SdsHeader>
) => {
    const { isParentLoading, currentParentRecord, handleFieldChange } =
        props.parentData;

    const { disabledField } = props.permissions;

    return (
        <FormPartial
            link={props?.link}
            title={
                (
                    <TranslatableText
                        termSet={props.termSet}
                        termKey={SDSFormDefs.Composition_Ingredient_Information}
                    />
                ) as unknown as string
            }>
            <FormPartial
                title={
                    (
                        <TranslatableText
                            termSet={props.termSet}
                            termKey={SDSFormDefs.Chemical_Composition}
                        />
                    ) as unknown as string
                }>
                <>
                    {isParentLoading ? (
                        <DatacorLogoSpinner />
                    ) : (
                        <>
                            <CheckBoxInput
                                id="substance"
                                label={
                                    (
                                        <TranslatableText
                                            termSet={props.termSet}
                                            termKey={SDSFormDefs.Substance}
                                        />
                                    ) as unknown as string
                                }
                                checked={currentParentRecord.substance}
                                onChange={handleFieldChange}
                                disabled={disabledField}
                            />
                            <SdsCasCompositionGrid {...props} />
                            <br />
                            <SubSection3_1Form
                                {...props}
                                termSet={props.termSet}
                            />
                        </>
                    )}
                </>
            </FormPartial>
        </FormPartial>
    );
};

export default SdsCasCompositionForm;
